import React, {useState} from 'react'
import {Link, useRouteMatch} from "react-router-dom";
import classNames from 'classnames'
import {useSelector} from "react-redux";
import SupportPopup from "./addons/support_popup";
import {HotspotPreview} from "../../../../shared/virtual_congress/components/hotspot_preview";

import house from "custom/flavepalfingeroft2021/menu/house.png"
import pfeil from "custom/flavepalfingeroft2021/menu/pfeil.png"
import info from "custom/flavepalfingeroft2021/menu/info.png"

function NavigationLink({to, icon, onClick, activeOnlyWhenExact, matchNever, ...props}) {
  // let match = false
  let match = useRouteMatch({
    path: to,
    exact: true
  });

  return to ? <Link to={to} className={classNames("col-12 col-md nav-elem", (match) ? "no-dot" : "", props.className)}>
    {match && <img className="icon-responsive" src={pfeil}  style={{width: "35px", fontSize: "3rem", margin: "auto", marginTop: "-26px", marginBottom: "8px"}}/>}
    <span class={"nav-element-text"}>{props.children}</span>
    {/*{!match && <i className="fa fa-chevron-right float-right" style={{marginTop: "0.2rem"}}/>}*/}
  </Link> : <div className={"col-1 nav-elem"} onClick={onClick}>
    <span class={"nav-element-text"}>{props.children}</span>
    {/*{!match && <i className="fa fa-chevron-right float-right" style={{marginTop: "0.2rem"}}/>}*/}
  </div>
}

export default function Navigation(props) {
  const imageMaps = useSelector((state) => state.imageMaps)
  const imageMapConfigs = useSelector((state) => state.imageMapConfigs)
  const imageHotspots = useSelector((state) => state.imageHotspots)
  const imageHotspotConfigs = useSelector((state) => state.imageHotspotConfigs)


  const tagOwner = useSelector(state => state.tagOwner)
  const [showSupportModal, setShowSupportModal] = useState(false)

  const [selectedHotspot, setSelectedHotspot] = useState(null)
  const imageMapIdentifier = tagOwner.external_id != "public_tag_owner" ? "entrance_lobby" : "entrance_lobby_public"
  const mappings = useSelector(state => (state.htmlContents || []).find(hc => hc.identifier == "public_redirects")?.json || {})

  const setPreselectedHotspot = (imageMapIdentifier, hotspotConfigIdentifier) => {
    const imageMap = imageMaps.find((img) => img.identifier == imageMapIdentifier)
    const preselectedImageHotspotConfig = imageHotspotConfigs.find((ihc) => ihc.identifier == hotspotConfigIdentifier)
    const preselectedHotspot = imageHotspots.find((ih) => ih.image_hotspot_config_id == preselectedImageHotspotConfig?.id && ih.image_map_id == imageMap?.id)
    setSelectedHotspot(preselectedHotspot)
  }

  return <>
    {showSupportModal && <SupportPopup onModalClose={() => setShowSupportModal(false)}/>}

    {selectedHotspot && <HotspotPreview
      hotspot={selectedHotspot}
      key={selectedHotspot?.id}
      id={selectedHotspot?.id}
      kind={selectedHotspot.kind}
      data={selectedHotspot.data}
      onModalClose={() => setSelectedHotspot(null)}/>}
    <div>
      <div className={classNames("navigation shadow p-2 row")}>
        <div className="col-md-10">
          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                <NavigationLink to={mappings["/"] || "/"}>
                  Main
                  HALL
                </NavigationLink>
                <NavigationLink to={mappings["/imgi/factory_tour"] || "/imgi/factory_tour"}>
                  Factory Tour
                </NavigationLink>
                <NavigationLink to={mappings["/imgi/cinema"] || "/imgi/cinema"}>
                  Cinema
                </NavigationLink>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="row">
                <NavigationLink to={mappings["/imgi/infopoint_crane"] || "/imgi/infopoint_crane"}>
                  Infopoint Crane
                </NavigationLink>
                <NavigationLink to={mappings["/imgi/game_zone"] || "/imgi/game_zone"}>
                  Game Zone
                </NavigationLink>
                <NavigationLink to={mappings["/imgi/chat_lounge"] || "/imgi/chat_lounge"}>
                  Chat Lounge
                </NavigationLink>
              </div>
            </div>
          </div>
        </div>
        {/*<div className="col-md-2">*/}
        {/*  <div className="row">*/}
        {/*    <Link to={"/imgi/home"} className={classNames("nav-elem col-md-6 pl-md-0 no-dot")}>*/}
        {/*      <img className="icon d-none d-md-block" src={house}  style={{width: "35px", fontSize: "3rem", margin: "auto", marginTop: "-26px", marginBottom: "8px"}}/>*/}
        {/*      /!*<i className="fas fa-home" style={{fontSize: "3rem", marginTop: "-31px", marginRight: "10px", marginBottom: "6px"}}/>*!/*/}
        {/*      <div className="d-block d-md-none">*/}
        {/*        Home*/}
        {/*      </div>*/}
        {/*    </Link>*/}
        {/*    <div className={"nav-elem col-md-6 pl-md-0 no-dot"} onClick={(e) => {*/}
        {/*      setPreselectedHotspot("entrance_lobby", "info_faq")*/}
        {/*      // e.preventDefault()*/}
        {/*      // e.stopPropagation()*/}
        {/*    }}>*/}
        {/*      <img className="icon d-none d-md-block" src={info}  style={{width: "35px", fontSize: "3rem", marginTop: "-26px", marginBottom: "8px"}}/>*/}
        {/*      /!*<i className="fas fa-exclamation-triangle" style={{color: "#FFED00", fontSize: "3rem", marginLeft: "10px", marginTop: "-31px", marginBottom: "6px"}}/>*!/*/}
        {/*      <div className="d-block d-md-none">*/}
        {/*        Info*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
    </div>
  </>
}

